import {
    CREATE_WASHING_INWARD_MASTER_REQUEST_DK,
    CREATE_WASHING_INWARD_MASTER_SUCCESS_DK,
    CREATE_WASHING_INWARD_MASTER_FAILURE_DK,
    DELETE_WASHING_INWARD_MASTER_REQUEST_DK,
    DELETE_WASHING_INWARD_MASTER_SUCCESS_DK,
    DELETE_WASHING_INWARD_MASTER_FAILURE_DK,
    FETCH_SINGLE_WASHING_INWARD_MASTER_REQUEST_DK,
    FETCH_SINGLE_WASHING_INWARD_MASTER_SUCCESS_DK,
    FETCH_SINGLE_WASHING_INWARD_MASTER_FAILURE_DK,
    FETCH_WASHING_INWARD_MASTER_REQUEST_DK,
    FETCH_WASHING_INWARD_MASTER_SUCCESS_DK,
    FETCH_WASHING_INWARD_MASTER_FAILURE_DK,
    UPDATE_WASHING_INWARD_MASTER_REQUEST_DK,
    UPDATE_WASHING_INWARD_MASTER_SUCCESS_DK,
    UPDATE_WASHING_INWARD_MASTER_FAILURE_DK,
    RESET_WASHING_INWARD_MASTER_INFO_DK,
    CREATE_WASHING_INWARD_MASTER_FORM_DK,
    UPDATE_WASHING_INWARD_MASTER_FORM_DK,
    NAVIGATE_WASHING_INWARD_DETAILS_DK,
    NAVIGATE_WASHING_INWARD_MASTER_DK,
    FETCH_PENDING_WASHING_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_WASHING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_WASHING_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_WASHING_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_WASHING_INWARD_ID_DK
} from './washingInwardHeader.actionsType';

export const WASHING_INWARD_DK_MASTER = 'washingInwardDKHeader';

let initialState = {
    loading: false,
    washingInwardHeader: [],
    pendingWashingDc: [],
    activeKey: 1,
    washingInwardId: '',
    washingInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,

        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldRoundoff: 0
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singleWashingInwardData: {},
    isWashingInwardDetails: false
};

export let washingInwardDKHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_WASHING_INWARD_MASTER_REQUEST_DK:
        case FETCH_PENDING_WASHING_PO_IN_INWARD_REQUEST_DK:
        case CREATE_WASHING_INWARD_MASTER_REQUEST_DK:
        case UPDATE_WASHING_INWARD_MASTER_REQUEST_DK:
        case FETCH_SINGLE_WASHING_INWARD_MASTER_REQUEST_DK:
        case DELETE_WASHING_INWARD_MASTER_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_WASHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardHeader: updatePayload
            };
        case FETCH_PENDING_WASHING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingWashingDc: updatePayload
            };
        case CREATE_WASHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                washingInwardId: updatePayload[0]?.fldID,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case UPDATE_WASHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case FETCH_SINGLE_WASHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_WASHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case RESET_WASHING_INWARD_MASTER_INFO_DK:
            return {
                ...state,
                washingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                washingInwardId: '',
                activeKey: 1
            };
        case CREATE_WASHING_INWARD_MASTER_FORM_DK:
        case UPDATE_WASHING_INWARD_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                washingInwardHeaderForm: {
                    ...state.washingInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_WASHING_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case FETCH_WASHING_INWARD_MASTER_FAILURE_DK:
        case FETCH_PENDING_WASHING_PO_IN_INWARD_FAILURE_DK:
        case CREATE_WASHING_INWARD_MASTER_FAILURE_DK:
        case UPDATE_WASHING_INWARD_MASTER_FAILURE_DK:
        case FETCH_SINGLE_WASHING_INWARD_MASTER_FAILURE_DK:
        case DELETE_WASHING_INWARD_MASTER_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case RESET_FORM_DATA_WITHOUT_WASHING_INWARD_ID_DK:
            return {
                ...state,
                washingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_WASHING_INWARD_DETAILS_DK:
            return {
                ...state,
                isWashingInwardDetails: true,
                singleWashingInwardData: updatePayload.singleWashingInwardData
            };
        case NAVIGATE_WASHING_INWARD_MASTER_DK:
            return {
                ...state,
                isWashingInwardDetails: false
            };
        default:
            return state;
    }
};
